import * as React from "react";
import { connect } from "react-redux";

import { FastTrackPitPupMedicalForm } from "./FastTrackPitPupMedicalForm";

import { Location } from "redux-little-router";

export interface StateProps {
    ohCaseId?: string;
}

export const ReadonlyFastTrackPitPupMedicalFormUnconnected: React.FunctionComponent<StateProps> = (props: StateProps) => {
    return (
        <FastTrackPitPupMedicalForm readonly ohCaseId={props.ohCaseId} />
    );
};

const mapStateToProps = (
    state: {
        router: Location;
    }): StateProps => {

    const ohCaseId = state.router.params && state.router.params.ohCaseId;
    return {
        ohCaseId
    };
};

export const ReadonlyFastTrackPitPupMedicalForm = connect(mapStateToProps)(ReadonlyFastTrackPitPupMedicalFormUnconnected);
